import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class ChangeMasterService {

  constructor( private httpService: HttpService) { }

    saveChargeCreationData(object) {
        var request = {
            URL: "chargeMaster/saveChargeCreationDetails",
            DATA: object
        }
        return this.httpService.post(request);
    }

    updateChargeModificationData(object) {
        var request = {
            URL: "chargeMaster/updateChargeModificationDetails",
            DATA: object
        }
        return this.httpService.post(request);
    }

    updateChargeSatisfactionData(object) {
        var request = {
            URL: "chargeMaster/updateChargeSatisfactionDetails",
            DATA: object
        }
        return this.httpService.post(request);
    }

    getChargeMaster(object) {
        var registerList = {
            URL: "chargeMaster/getChargeDetailsList",
            DATA: object
        }
        return this.httpService.post(registerList);
    }

    removeChargeMasterdetails(_id) {
        var request = {
            URL: "chargeMaster/deleteChargeDetails/" + _id
        }
        return this.httpService.get(request);
    }

    getChargeMasterById(_id) {
        var editlist = {
            URL: "chargeMaster/getChargeMasterById/" + _id,
        }
        return this.httpService.get(editlist);
    }

    updateChargeMaster(object, id) {
        var request = {
            URL: "chargeMaster/updateChargeMasters/" + id,
            DATA: object
        }
        return this.httpService.post(request);
    }
    generateChargeMaster(object) {
        var request = {
            URL: "chargeMaster/generateChargeMaster",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadChargeMasterFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "chargeMaster/downloadDocument/" + id + "/" + type + "/" + token;
    }

    downloadChargeMasterPdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "chargeMaster/downloadPdfDocument/" + id + "/" + type + "/" + token;
    }

}


